export default __webpack_public_path__ + "static/media/mec-7.9dcdbf1a.png";